import { Component, Injectable, Input, Output, EventEmitter, OnInit, forwardRef } from '@angular/core';
import { ITextValue } from '../../../models/ITextValue';
import { Observable } from 'rxjs/Observable';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';


@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppDropdownComponent),
      multi: true
    }
  ]
})

@Injectable()
export class AppDropdownComponent implements ControlValueAccessor {
  _value: string;

  constructor() {
    this.select = new EventEmitter();
  }

  @Input() collection: ITextValue[];
  @Input() css: string;
  @Output() select: EventEmitter<string>;

  selected: ITextValue;

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    if (value != null && value !== this._value) {
      this._value = value;

      if (value === '') {
        this.selected = null;
        this.select.emit(null);
        return;
      }

      this.selected = _.find(this.collection, item => value.toString() === item.value.toString());
      this.select.emit(value);
      this.propagateChange(value);
    }
  }

  writeValue(value: any): void {
    if (value != null && value !== this._value) {
      this.value = value;
    }
  }

  propagateChange = (_: any) => { };
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }
  setDisabledState?(isDisabled: boolean): void { }

  selectedChanged(event: string): void {
    if (event != null) {
      this.value = event;
    }
  }
}
